<template>
    <div>
        <div class="search_head">
            <a-form layout="inline" style="padding: 0">
                <a-form-item label="">
                    <a-input v-model="kw" style="width:250px"></a-input>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" html-type="submit" @click="query()">
                        搜索
                    </a-button>
                </a-form-item>
            </a-form>
        </div>
        <div class="search_content">
            <a-table :columns="columns" :data-source="table" bordered size="small" :loading="loading"
                :pagination="pagination" :rowKey="(record, index) => { return index }" @change="change">
                <span slot="detail" slot-scope="row">
                    <a-button @click="show_drawer(row)" size="small" type="link">
                        查看
                    </a-button>
                    <a-drawer width="640" placement="right" :visible="visible" @close="close_drawer">
                        <!-- <p class="drawer_p  drawer_p2">产品素材：</p> -->
                        <p class="drawer_p">关键词：</p>
                        <a-tag v-for="kw in kws" :key="kw.keyword_id">{{ kw.content }}</a-tag>
                        <p class="drawer_p">长尾词：</p>
                        <a-tag v-for="kw in kws2" :key="kw.keyword_id">{{ kw.content }}</a-tag>
                        <a-divider />

                        <p class="drawer_p">字幕：</p>
                        <a-row v-for="(subtitle, index) in subtitles" :key="index">{{ index + 1 }}.{{ subtitle.content
                        }}</a-row>
                        <a-divider />
                        <div v-for="(album, index) in albums">
                            <p class="drawer_p">
                                相册{{ index + 1 }}： {{ album.album_name }}
                            </p>
                            <a :href="file.url" v-for="file in album.list" style="cursor: pointer" target="_blank">
                                <a-tag style="cursor: pointer">{{ file.name }}</a-tag>
                            </a>
                        </div>
                        <a-divider />
                    </a-drawer>
                </span>
            </a-table>
        </div>
    </div>
</template>
<script>
import { get, post } from "../../assets/js/request";
export default {
    data() {
        return {
            table: [],
            pagination: {
                current: 1,
                pageSize: 20,
                total: 0,
            },
            kw: '',
            columns: [
                {
                    title: '序号',
                    customRender: (text, record, index) => `${index + 1}`,
                    width: 50,
                }, {
                    title: "id",
                    dataIndex: "product_id",
                },
                {
                    title: "名称",
                    dataIndex: "name",
                }, {
                    title: "字幕",
                    dataIndex: "subtitles_num",
                }, {
                    title: "关键词",
                    dataIndex: "keywords_num",
                },
                {
                    title: "相册",
                    dataIndex: "album_num",
                },
                {
                    title: "任务数",
                    dataIndex: "task_num",
                },
                {
                    title: "时间",
                    dataIndex: "create_time",
                },
                {
                    title: "描述",
                    dataIndex: "msg",
                    ellipsis: true,
                },
                {
                    title: "素材",
                    scopedSlots: { customRender: "detail" },
                },
            ],
            loading: false,
            visible: false,
            kws: [],
            kws2: [],
            albums: [],
            subtitles: [],
            files: []
        };
    },
    created() {
        this.loadtable();
    },
    methods: {
        loadtable() {
            this.loading = true;
            get("/product/list", {
                page: this.pagination.current,
                size: this.pagination.pageSize,
                search: this.kw,
            }).then((res) => {
                this.loading = false;
                this.table = res.data.data;
                this.pagination.total = res.data.total;
            });
        },
        change(pagination) {
            this.pagination = pagination;
            this.loadtable();
        },
        query() {
            this.pagination.current = 1;
            this.loadtable();
        },
        show_drawer(row) {
            this.visible = true;
            this.kws = [];
            this.kws2 = [];
            this.albums = [];
            this.subtitles = [];

            let pid = row.product_id;
            //关键词
            this.getkws(pid);
            //相册
            this.getalums(pid)
            //字幕
            this.getsubtitle(pid);

        },
        close_drawer() {
            this.visible = false;
        },
        getkws(pid) {
            get('/kw/list', { product_id: pid, type: 'keyword' }).then(res => {
                this.kws = res.data;
            })
            get('/kw/list', { product_id: pid, type: 'longword' }).then(res => {
                this.kws2 = res.data;
            })
        },

        getalums(pid) {
            get('/album/list', { product_id: pid }).then(res => {
                let list = res.data.data;
                for (let i in list) {
                    this.albumdetail(list[i].album_id);
                }
            })
        },
        albumdetail(albumid) {
            get('/album/detail', { album_id: albumid }).then(res => {
                this.albums.push(res.data);
            })
        },
        getsubtitle(pid) {
            get('/subtitle/list', { product_id: pid }).then(res => {
                this.subtitles = res.data.data;
            })
        }

    },
};
</script>